import { IGioCongDong } from "../../../models/response/gio-cong-dong/IGioCongDong";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objGioCongDongDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IGioCongDong[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IGioCongDong | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IGioCongDong,
    SAVE_SUCESS: {} as IGioCongDong,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eGioCongDongActionTypeIds = generateActionTypeIds(objGioCongDongDefine, "GIO_CONG_DONG")
export type IGioCongDongActionTypes = IGenericActionType<typeof objGioCongDongDefine, "GIO_CONG_DONG">
